import { zYesno } from '@/utils';
import { z } from 'zod';

export const RegionSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  is_active: z.boolean().optional(),
});

export const RegionSearchSchema = z.object({
  search: z.string().optional(),
  is_active: zYesno().optional(),
});

export type RegionSchemaType = z.infer<typeof RegionSchema>;
